import { defineMessages } from 'react-intl'

export default defineMessages({
  searchPlaceholder: {
    id: 'app.search.placeholder',
    defaultMessage: 'Search Flix Premiere',
  },
  searchBy: {
    id: 'app.search.searchBy',
    defaultMessage: 'Search by title, genre, or actor',
  },
  noResults: {
    id: 'app.search.noResults',
    defaultMessage: 'No results, please broaden your search',
  },
})
